import React from 'react';
import { Form, Col, Row, Button, Navbar, Container, Image, Spinner } from 'react-bootstrap';
import axios, { AxiosRequestConfig } from 'axios';
import { Constants } from "../../constants";
import GuestSiteMenu from "../guest_menu";
import 'bootstrap/dist/css/bootstrap.min.css';
import ReactGA from "react-ga4";

class RegisterForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            input: {
                firstname: '',
                lastname: '',
                email: '',
                password: '',
                phonenumber: '',
                accountID: '',
                billingZip: '',
                confirmpassword: ''
            },
            isBasicRegistration: true,
            showForm: false,
            errors: {},
            loading: false
        };

        this.showButton = this.showButton.bind(this);
        this.handleFormChange = this.handleFormChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.validatePassword = this.validatePassword.bind(this);
        this.handleRegTypeChange = this.handleRegTypeChange.bind(this);
    }

    componentDidMount() {

        let params = new URLSearchParams(window.location.search);
        let foo = params.get('type');
        if (foo != null && foo == 'training') {
            this.setState({
                showForm: true,
                regType: 'basic-2'
            });
        }
    }

    handleFormChange(event) {
        let input = this.state.input;
        let errors = this.state.errors;

        input[event.target.name] = event.target.value;
        if (!!errors[event.target.name]) {
            errors[event.target.name] = null;
        }

        this.setState({
            input,
            errors
        });
    }

    handleRegTypeChange(event) {
        console.log(event.target.value);

        this.setState({
            isBasicRegistration: event.target.value.startsWith('account') ? false : true,
            regType: event.target.value,
            showForm:true
        });
    }

    validate(event) {

        let input = this.state.input;
        let errors = {};
        let isValid = true;

        if (!input["firstname"]) {
            isValid = false;
            errors["firstname"] = "Please enter your name.";
        }
        if (!input["lastname"]) {
            isValid = false;
            errors["lastname"] = "Please enter your name.";
        }

        if (!input["phonenumber"] || !String(input["phonenumber"])
            .match(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/)) {
            isValid = false;
            errors["phonenumber"] = "Invalid phone number.";
        }

        if (!input["email"] || !String(input["email"])
            .toLowerCase()
            .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            )) {
            isValid = false;
            errors["email"] = "Invalid email address.";
        }

        if (!input["password"]) {
            isValid = false;
            errors["password"] = "Please enter your password.";
        }

        if (!input["confirmpassword"]) {
            isValid = false;
            errors["confirmpassword"] = "Please confirm your password.";
        }

        if (!this.state.isBasicRegistration) {
            if (!input["accountID"]) {
                isValid = false;
                errors["accountID"] = "Invalid.";
            }
            if (!input["billingZip"] || !String(input["billingZip"])
                .toLowerCase()
                .match(/^[0-9]{5}(?:-[0-9]{4})?$/
                )) {
                isValid = false;
                errors["billingZip"] = "Invalid zip code.";
            }
        }

        if (typeof input["password"] !== "undefined" && typeof input["confirmpassword"] !== "undefined") {

            if (input["password"] != input["confirmpassword"]) {
                isValid = false;
                errors["confirmpassword"] = "Passwords don't match.";
            }
        }

        this.setState({
            errors: errors
        });

        return isValid;
    }

    validatePassword(event) {
        let input = this.state.input;
        input["password"] = event.target.value;
        let errors = this.state.errors;
        if (typeof input["password"] == "undefined" || !String(input["password"])
            .match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,20}$/)) {
            errors["password"] = <div style={{ lineHeight: .5, marginTop: 3 }}><p>Passwords require at least:</p><p>1 uppercase letter.</p><p>1 lowercase letter.</p><p>1 number.</p><p>1 symbol.</p><p>8-16 characters in length.</p></div>
        }
        else {
            errors["password"] = "";
        }

        this.setState({
            input: input,
            errors: errors
        });
    }

    showButton() {
        if (this.state.showForm) {
            if (this.state.loading) {
                return <Button style={{ marginLeft: '30px', backgroundColor: '#1F419B' }} variant="primary" disabled>
                    <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true" />
                    <span className="visually-hidden">Loading...</span>
                </Button>;
            }
            else {
                return <Button style={{ marginLeft: '30px', backgroundColor: '#1F419B' }} variant="primary" type="submit">
                    Register
                </Button>;
            }
        }
    }

    handleSubmit(event) {

        event.preventDefault();

        if (!this.validate()) {
            alert('Please fill in required fields to proceed.');
            return;
        }

        this.setState({ loading: true });

        axios.post(`${Constants.apiURL}/api/Identity/Register`, {
            firstname: this.state.input.firstname,
            lastname: this.state.input.lastname,
            email: this.state.input.email,
            password: this.state.input.password,
            phonenumber: this.state.input.phonenumber,
            accountID: this.state.input.accountID,
            billingZip: this.state.input.billingZip
        }).then(response => {
            console.log(response);
            if (response.status == 200 && response.data == true) {
                ReactGA.event({
                    category: 'Registration',
                    action: 'Registration',
                    label: 'Registration'
                });
                alert('Account created. Please login below.');
                this.props.history.push({
                    pathname: '/'
                });
            }
            else {
                alert(response.data);
            }
            this.setState({ loading: false });
        }).catch((error) => {
            this.setState({ loading: false });
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                alert('Unable to register your account.Please email clientportal @boland.com to request an account.');
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                alert('Error contacting server. Please try again soon.')
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }
        });
    }

    render() {
        return (
            <div>
                <GuestSiteMenu currentPage='register' />
                <Form onSubmit={this.handleSubmit} noValidate >
                    <Row style={{ padding: '10px', margin: '10px', maxWidth: '800px' }} className="mb-3">
                    <Col md={8}>
                        <Form.Label className="form-header">Client Portal Registration</Form.Label>
                        <Form.Label style={{ fontSize: '16px', marginTop: '-5px', paddingTop: '0px', fontWeight:'bold' }}>
                                Please indicate your primary registration need below.
                            </Form.Label>
                            <Form.Label style={{ fontSize: '15px', marginTop: '-5px', paddingTop: '0px', fontStyle: 'italic' }}>You can always update your profile after logging in if you expect to use more than one of these features. Please select your current need for a portal account.</Form.Label>

                            <Form.Select name="regType" value={this.state.regType} onChange={this.handleRegTypeChange}>
                                <option value="" hidden={true}>Select primary registration need...</option>
                            <option value="account-1">Service tracking</option>
                            <option value="account-2">Invoice management</option>
                            <option value="account-3">Parts & supply orders</option>
                            <option value="basic-1">Contractor portal & job bid list</option>
                            <option value="basic-2">Training portal</option>
                        </Form.Select>
                    </Col>
                    </Row>
                    <Row style={{ padding: '10px', margin: '10px', maxWidth: '800px' }} className="mb-3">
                        <Col md={6} hidden={!this.state.showForm}>
                            <Form.Label style={{ paddingBottom: '24px' }} className="form-header">Your information</Form.Label>
                            <Form.Group className="mb-3" controlId="formFirstname">
                                <Form.Label>First name</Form.Label>
                                <Form.Control type="input" name="firstname" value={this.state.input.firstname} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.firstname} />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formLastname">
                                <Form.Label>Last name</Form.Label>
                                <Form.Control type="input" name="lastname" value={this.state.input.lastname} onChange={this.handleFormChange} required
                                    isInvalid={!!this.state.errors.lastname} />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formPhoneNumber">
                                <Form.Label>Phone number</Form.Label>
                                <Form.Control type="phone" name="phonenumber" value={this.state.input.phonenumber} onChange={this.handleFormChange} required
                                    isInvalid={!!this.state.errors.phonenumber} />
                                <Form.Control.Feedback type='invalid'>
                                    {this.state.errors.phonenumber}
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Email address</Form.Label>
                                <Form.Control type="email" name="email" value={this.state.input.email} onChange={this.handleFormChange} required
                                    isInvalid={!!this.state.errors.email} />
                                <Form.Control.Feedback type='invalid'>
                                    {this.state.errors.email}
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formBasicPassword">
                                <Form.Label>Password</Form.Label>
                                <Form.Control type="password" name="password" value={this.state.input.password} onChange={this.validatePassword} required
                                    isInvalid={!!this.state.errors.password} />
                                <Form.Control.Feedback type='invalid'>
                                    {this.state.errors.password}
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formBasicPasswordConfirm">
                                <Form.Label>Confirm password</Form.Label>
                                <Form.Control type="password" name="confirmpassword" value={this.state.input.confirmpassword} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.confirmpassword} />
                                <Form.Control.Feedback type='invalid'>
                                    {this.state.errors.confirmpassword}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col md={6} hidden={this.state.isBasicRegistration}>
                            <Form.Label style={{ paddingBottom: '24px' }} className="form-header">Boland account information</Form.Label>
                            <div>
                                <Form.Group className="mb-3" controlId="formCustomerAccount">
                                    <Form.Label>Customer account number</Form.Label>
                                    <Form.Control type="input" name="accountID" value={this.state.input.accountID} onChange={this.handleFormChange}
                                        isInvalid={!!this.state.errors.accountID} />
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="formBillingZip">
                                    <Form.Label>Billing address zip code</Form.Label>
                                    <Form.Control type="input" name="billingZip" value={this.state.input.billingZip} onChange={this.handleFormChange}
                                        isInvalid={!!this.state.errors.billingZip} />
                                    <Form.Control.Feedback type='invalid'>
                                        {this.state.errors.billingZip}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Label style={{ fontSize: '15px', marginTop: '-8px', paddingTop: '0px', fontStyle: 'italic', fontWeight: 'bold' }}>
                                    Don't know your Boland account information?</Form.Label>
                                <Form.Label style={{ fontSize: '15px', marginTop: '-5px', paddingTop: '0px', fontStyle: 'italic' }}>
                                    These numbers may be found on Boland invoices.<br />
                                    Please contact your company's billing department or your Boland account executive if you cannot locate account information.</Form.Label>
                            </div>
                        </Col>
                    </Row>
                    {this.showButton()}
                </Form>
            </div>
        );
    }
}

export default RegisterForm;